import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Currency } from '@teko/ui';
import { Image } from '@teko/ds-foundation';
import { PrintBuildPcItem } from './PrintBuildPcItem.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const Wrapper = styled.div`
  display: none;
  @media print {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    z-index: 99999;
    width: 100%;
    height: 100%;
  }
`;
const Header = styled.div`
  padding: 1rem;
  text-align: center;
  background: #ebecee;
  width: 100%;
`;
const Logo = styled.div``;
const Content = styled.div`
  padding: 1rem;
  width: 100%;
`;
const Footer = styled.div`
  padding: 1rem;
  width: 100%;
  text-align: center;
`;
const Total = styled.div`
  font-size: 1.5rem;
  color: #d10000;
  font-weight: 500;
`;
const PrintBuildPc = ({
  total,
  buildpc,
  logoProps
}) => {
  if (!Object.keys(buildpc).length)
    return null;
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement(Logo, null, /* @__PURE__ */ React.createElement(Image, __spreadValues({
    src: "https://phongvu.vn/phongvu/logo-full.svg",
    height: 80,
    lazy: false
  }, logoProps)))), /* @__PURE__ */ React.createElement(Content, null, Object.keys(buildpc).map((key) => {
    const product = buildpc[key].product;
    const quantity = buildpc[key].quantity;
    return /* @__PURE__ */ React.createElement(PrintBuildPcItem, {
      quantity,
      key,
      product
    });
  })), /* @__PURE__ */ React.createElement(Footer, null, /* @__PURE__ */ React.createElement(Total, null, t("T\u1ED5ng chi ph\xED:"), " ", /* @__PURE__ */ React.createElement(Currency, {
    value: total
  }))));
};

export { PrintBuildPc };
